module.exports = "<event-page></event-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/event.html
// module id = 1914
// module chunks = 0